import { Grid } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import TicketOverview from "../Ticketing/TicketOverview";
import CancelledAppointmentsWidget from "./CancelledAppointmentsWidget";
import UnscheduledAppointmentsWidget from "./UnscheduledAppointmentsWidget";
import TeamDigest from "./TeamDigest";
import PersonalDigest from "./PersonalDigest";
import RxOrdersDigest from "./RxOrdersDigest";
import RxOrdersOverview from "./RxOrdersOverview";

const Dashboard = () => {
  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          border: "0px dashed green",
          overflowY: "auto",
        }}
      >
        {/* First row: 4 widgets each taking 3/12 = 25% width */}
        <Grid item xs={12} sm={2.5}>
          <TeamDigest />
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <PersonalDigest />
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <RxOrdersOverview />
        </Grid>
        <Grid item xs={12} sm={4.5}>
          <TicketOverview />
        </Grid>

        {/* Second row: 2 widgets each taking 6/12 = 50% width */}
        <Grid item xs={12} sm={6}>
          <UnscheduledAppointmentsWidget />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CancelledAppointmentsWidget />
        </Grid>
      </Grid>
    </>
  );
};
export default Dashboard;
